/*
 * @Description: 
 * @Author: 赵大壮
 * @Date: 2024-07-21 17:04:05
 * @LastEditTime: 2024-07-22 06:34:40
 * @LastEditors: 赵大壮
 */
import config from '../nyConfig'
const ApiVideo = {
    "添加视频": new config({ url: '/video/addVideo', showSuccessMessage: true, useToken: true }),
    "修改视频": new config({ url: '/video/editVideo', showSuccessMessage: true, useToken: true }),
    "视频列表": new config({ url: '/video/listVideo', showSuccessMessage: false, useToken: true }),
    "删除视频": new config({ url: '/video/delVideo', showSuccessMessage: false, useToken: true }),
    "视频详情": new config({ url: '/video/getVideo', showSuccessMessage: false, useToken: true }),
    "所有视频": new config({ url: '/video/listVideoAll', showSuccessMessage: false, useToken: true }),
    "添加视频分类": new config({ url: '/video/addType', showSuccessMessage: true, useToken: true }),
    "修改视频分类": new config({ url: '/video/editType', showSuccessMessage: true, useToken: true }),
    "删除视频分类": new config({ url: '/video/delType', showSuccessMessage: true, useToken: true }),
    "视频分类列表": new config({ url: '/video/listType', showSuccessMessage: false, useToken: true }),
    "视频分类字典列表": new config({ url: '/video/listTypeDic', showSuccessMessage: false, useToken: true }),
    "修改视频排序": new config({ url: '/video/saveSort', showSuccessMessage: true, useToken: true }),
    "视频数据上移": new config({ url: '/video/moveUp', showSuccessMessage: true, useToken: true }),
    "视频数据下移": new config({ url: '/video/moveDown', showSuccessMessage: true, useToken: true }),
    "视频数据置顶": new config({ url: '/video/moveTop', showSuccessMessage: true, useToken: true }),
    "视频取消置顶": new config({ url: '/video/cancelTop', showSuccessMessage: true, useToken: true }),
}

export default ApiVideo